import styled from "styled-components/native";
import { Theme } from "../../helpers";

export const MainContainer = styled.View`
  padding: 0 1rem;
`;
